module.exports = __webpack_public_path__ + "static/datawise-5c93637b3181023f8d20aa7a866ac002.svg";